import { haptic } from '../lib/telegram';

export type Tab = 'wheel' | 'tasks' | 'course' | 'shop' | 'profile';

const TABS: { id: Tab; label: string; d: string }[] = [
  { id: 'wheel', label: 'Колесо', d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 0v9l6.4 6.4' },
  { id: 'tasks', label: 'Задания', d: 'M9 7h11M9 12h11M9 17h7M4 6.8l1 1 1.8-2M4 11.8l1 1 1.8-2M4 16.8l1 1 1.8-2' },
  { id: 'course', label: 'Курс', d: 'M4 5.5 12 3l8 2.5V17l-8 2.5L4 17zM12 3v16.5' },
  { id: 'shop', label: 'Магазин', d: 'M4 8h16l-1.2 11H5.2zM8.5 8V6a3.5 3.5 0 0 1 7 0v2' },
  { id: 'profile', label: 'Профиль', d: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20a7.5 7.5 0 0 1 15 0' },
];

function Glyph({ d, active }: { d: string; active: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d={d} stroke={active ? 'var(--gold)' : 'var(--ash)'} strokeWidth="1.7"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TabBar({ tab, onChange }: { tab: Tab; onChange: (t: Tab) => void }) {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-surface/95 backdrop-blur-xl
                    pb-[max(6px,env(safe-area-inset-bottom))]">
      <div className="mx-auto flex max-w-md">
        {TABS.map((t) => {
          const active = t.id === tab;
          return (
            <button key={t.id} onClick={() => { haptic.tap(); onChange(t.id); }}
              aria-current={active ? 'page' : undefined}
              className="flex flex-1 flex-col items-center gap-1 py-2.5">
              <Glyph d={t.d} active={active} />
              <span className={`text-[10px] font-semibold ${active ? 'text-gold' : 'text-ash'}`}>{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
